import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

import { ActionButtonComponent } from "../../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-enable-mfa",
	templateUrl: "./enable-mfa.component.html",
	styleUrls: ["./enable-mfa.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class EnableMfaComponent implements OnInit {
	private router = inject(Router);
	private api = inject(ApiService);

	public mfaInfo: any;
	public mfa_code: string;
	public errormessage: string;

	async ngOnInit() {
		try {
			this.mfaInfo = await this.api.GetMfaQrCode();
		} catch (err) {
			if (err?.error?.message === "Affected 0 rows") {
				this.errormessage = "MFA is already enabled on this account.";
				this.router.navigate(["/dash/account"]);
			} else {
				this.errormessage = "Failed to enable MFA. Please try again.";
			}
		}
	}

	async EnableMFA() {
		if (!this.mfa_code) throw new Error("MFA code is required");
		await this.api.EnableMFA(this.mfa_code);
		setTimeout(() => {
			this.router.navigate(["/dash/account"]);
		}, 1000);
	}
}
